import { PriceInfo, ProductInformation, DiscountInfo } from "@/data/client";

export function quantityInRange(
  quantity: number,
  row: PriceInfo | DiscountInfo
): boolean {
  const from = row.fromQuantity!;
  const to = row.toQuantity; // null => open-ended

  return from <= quantity && (to == null || quantity <= to);
}

export function findPriceRange(
  quantity: number,
  priceRules: PriceInfo[]
): PriceInfo | null {
  if (!priceRules || priceRules.length === 0) return null;

  for (const price of priceRules) {
    if (quantityInRange(quantity, price)) return price;
  }
  return null;
}

export function findSeparateDiscount(
  quantity: number,
  discounts?: DiscountInfo[] | null
): DiscountInfo | null {
  if (!discounts || discounts.length === 0) return null;

  for (const disc of discounts) {
    if (quantityInRange(quantity, disc)) return disc;
  }
  return null;
}

// 3. Compute applicable discount percent for product and entered order quantity
export function getEffectiveDiscountPercent(
  product: ProductInformation,
  quantity: number,
  priceRange?: PriceInfo
): number {
  const price = priceRange ?? findPriceRange(quantity, product.priceRules!);
  const mergedDiscount = price?.discount ?? 0;

  if (mergedDiscount > 0) return mergedDiscount;

  const separateDisc = findSeparateDiscount(quantity, product.discounts);
  return separateDisc?.discount ?? 0;
}
